import { TelecommunicationEquipmentTypeSchema, } from '@eigtech/contacts-types';
import { isDefined } from '@eigtech/function-utils';
import { isInEffect } from '../utils/inEffect.js';
import { hasLowerPreferenceOrder, isAnEmail } from './helpers.js';
export const getContactEmails = (contact) => {
    if (!contact?.communicationInformation?.length) {
        return undefined;
    }
    return contact.communicationInformation
        .filter((comm) => comm.telecommunicationEquipmentType === TelecommunicationEquipmentTypeSchema.enum.Email ||
        comm.emailAddress !== undefined)
        .map((email) => email.emailAddress)
        .filter(isDefined);
};
export const getContactPrimaryEmail = (contact) => {
    const potentialEmails = contact.communicationInformation?.filter((comm) => isAnEmail(comm) && isInEffect(comm));
    if (!potentialEmails?.length) {
        return undefined;
    }
    const preferredEmail = potentialEmails.reduce((prev, cur) => {
        // Prefer lower preference order
        if (hasLowerPreferenceOrder(cur, prev)) {
            return cur;
        }
        // Prefer a defined preferenceOrder
        if (prev.preferenceOrder === undefined && cur.preferenceOrder !== undefined) {
            return cur;
        }
        return prev;
    }, potentialEmails[0] // Initialize to first candidate
    );
    return preferredEmail;
};
export const getContactEmailAddress = (contact) => {
    const primaryEmail = getContactPrimaryEmail(contact);
    return primaryEmail?.emailAddress;
};
const normalizeEmail = (email) => email?.trim()?.toLowerCase();
export const doesContactMatchByEmail = (email, contact) => {
    if (!contact)
        return false;
    const contactEmails = getContactEmails(contact) ?? [];
    return contactEmails.some((ce) => normalizeEmail(ce) === normalizeEmail(email));
};
